import TKHeadingNav from '@tk/components/tk.heading.nav';

export default class DIWHeadingNav extends TKHeadingNav {
    private resizeObserver?: ResizeObserver;
    private scrollHandler?: () => void;

    constructor() {
        super();
    }

    connectedCallback() {
        this.render();
        this.setupHeadings();
        this.observeStickyElements();
    }

    disconnectedCallback() {
        this.resizeObserver?.disconnect();
        if (this.scrollHandler) {
            window.removeEventListener('scroll', this.scrollHandler);
        }
    }

    render() {
        this.updateStickyPosition();
    }

    updateStickyPosition() {
        const stickyHeaderHeight = this.calculateStickyHeaderHeight();
        this.style.top = `${stickyHeaderHeight}px`;
    }

    calculateStickyHeaderHeight(): number {
        const stickyHeader = document.querySelector('.tk-header--sticky');
        if (stickyHeader) {
            return stickyHeader.getBoundingClientRect().height;
        }
        return 0;
    }

    observeStickyElements() {
        const stickyHeader = document.querySelector('.tk-header--sticky');
        if (stickyHeader) {
            this.resizeObserver = new ResizeObserver(() => {
                this.updateStickyPosition();
                this.updateHeadingScrollMargins();
            });
            this.resizeObserver.observe(stickyHeader);
        }

        this.scrollHandler = () => {
            this.updateStickyPosition();
        };
        window.addEventListener('scroll', this.scrollHandler, { passive: true });
    }

    setupHeadings() {
        const container = document.querySelector(this.targetSelector);
        if (!container) return;

        const headings = Array.from(
            container.querySelectorAll<HTMLHeadingElement>(`${this.heading},[data-tk-heading-nav-item-title]`),
        );
        const nav = this.querySelector('[data-tk-navigation-element]');
        const underline = this.querySelector<HTMLElement>('[data-tk-underline-element]');
        if (!underline) return;

        nav?.querySelectorAll('.nav-item').forEach((e) => e.remove());

        this.updateHeadingScrollMargins();

        headings.forEach((heading) => {
            const item = document.createElement('div');
            item.classList.add('tk-button', 'tk-button--link');
            item.setAttribute('data-tk-nav-item-element', '');
            item.textContent = heading.hasAttribute('data-tk-heading-nav-item-title')
                ? heading.getAttribute('data-tk-heading-nav-item-title')
                : heading.textContent;
            item.addEventListener('click', () => {
                heading.scrollIntoView({ behavior: 'smooth', block: 'start' });
            });
            nav?.appendChild(item);
        });

        const navItems = Array.from(this.querySelectorAll<HTMLElement>('[data-tk-nav-item-element]'));
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    const index = headings.indexOf(entry.target as HTMLHeadingElement);
                    if (entry.isIntersecting) {
                        this.activateItem(navItems[index], underline);
                    }
                });
            },
            {
                threshold: 0,
            },
        );
        headings.forEach((h) => observer.observe(h));
    }

    updateHeadingScrollMargins() {
        const container = document.querySelector(this.targetSelector);
        if (!container) return;

        const headings = Array.from(
            container.querySelectorAll<HTMLHeadingElement>(`${this.heading},[data-tk-heading-nav-item-title]`),
        );
        const stickyHeaderHeight = this.calculateStickyHeaderHeight();
        const { height } = this.getBoundingClientRect();

        headings.forEach((heading) => {
            heading.style.scrollMarginTop = `${stickyHeaderHeight + height}px`;
        });
    }
}
